import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-textile-model-category5',
  templateUrl: './textile-model-category5.component.html',
  styleUrls: ['./textile-model-category5.component.css']
})
export class TextileModelCategory5Component implements OnInit {
    textileModelCategory5Keyno;

    public edit?: Edit;

    public saving = false;

    public textileModelCategory5LangNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'textilemodelcategory5lang', gotoParms: () => this.edit!.textilemodelcategory5_keyno ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.textileModelCategory5Keyno = this.stateService.getStateParams()['textilemodelcategory5_keyno'];
    }

    private async loadEdit() {
        if (!!this.textileModelCategory5Keyno) {
            this.edit = (await this.datatask.Post(2685, { textilemodelcategory5_keyno: this.textileModelCategory5Keyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2687, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    textilemodelcategory5_keyno: string;
    textilemodelcategory5lang_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory5', {
//        templateUrl: 'views/components/views/textileModelCategory5/textileModelCategory5.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'textileModelCategory5Service', 'translateService', function ($stateParams, stateService, modalService, textileModelCategory5Service, translateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory5Keyno = $stateParams.textilemodelcategory5_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                textileModelCategory5LangNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('textilemodelcategory5lang', { textilemodelcategory5_keyno: vm.model.edit.textilemodelcategory5_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await textileModelCategory5Service.getTextileModelCategory5({ textilemodelcategory5_keyno: textileModelCategory5Keyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory5Service.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
